import React, {Component} from 'react';
import { Link } from 'react-router-dom'
import MaestroArrowNode from './MaestroArrowNode';

export default class MaestroTreeNode extends Component {

  constructor(props) {
    super(props);
    this.state = {collapsed: true};
  }

  onClick() {
    this.setState({
      collapsed: !this.state.collapsed
    });
  }

  render() {

    let subtree = null;
    if (this.props.data.children) {
      subtree = this.props.data.children.map(function (child) {
        return <MaestroTreeNode key={child.id} data={child}/>;
      });
    }

    let arrowClassName = 'tree-node-arrow';
    let containerClassName = 'tree-node-children';
    if (this.state.collapsed) {
      arrowClassName += ' tree-node-arrow-collapsed';
      containerClassName += ' tree-node-children-collapsed';
    }

    if (subtree) {
      return (
        <div className="tree-node">
          <div className="divTable">
            <div className="divTableBody">
              <div className="divTableRow">
                <div className="divTableCell" onClick={this.onClick.bind(this)}>
                  <MaestroArrowNode arrowClassName={arrowClassName} child={true}/>
                    Grupo: {this.props.data.codGrupo} Tipo: {this.props.data.codTipo} {this.props.data.descripcion}
                </div>
                <div className="divTableCell" style={{ 'width': '5%'}}>
                  <Link
                    className="btn btn-default"
                    role="button"
                    to={{ pathname: '/mantenimiento-maestros/nuevo', state: { data: this.props.data, child: true} }}
                  ><i className="ion-android-add-circle"/></Link>
                </div>
                <div className="divTableCell" style={{ 'width': '5%'}}>
                  <Link
                    className="btn btn-default"
                    role="button"
                    to={{ pathname: '/mantenimiento-maestros/detalle', state: { data: this.props.data, child: false} }}
                  ><i className="ion-android-arrow-dropright-circle"/></Link>
                </div>
              </div>
            </div>
          </div>
          <div className={containerClassName}>
            {subtree}
          </div>
        </div>
      );
    }
    else {
      return (
        <div className="divTable">
          <div className="divTableBody">
            <div className="divTableRow">
              <div className="divTableCell">
                <MaestroArrowNode arrowClassName="tree-node-arrow" child={false}/>
                  Grupo: {this.props.data.codGrupo} Tipo: {this.props.data.codTipo} {this.props.data.descripcion}
              </div>
              <div className="divTableCell" style={{ 'width': '5%'}}>
                <Link
                  className="btn btn-default"
                  role="button"
                  to={{ pathname: '/mantenimiento-maestros/nuevo', state: { data: this.props.data, child: true} }}
                ><i className="ion-android-add-circle"/></Link>
              </div>
              <div className="divTableCell" style={{ 'width': '5%'}}>
                <Link
                  className="btn btn-default"
                  role="button"
                  to={{ pathname: '/mantenimiento-maestros/detalle', state: { data: this.props.data, child: false} }}
                ><i className="ion-android-arrow-dropright-circle"/></Link>
              </div>
            </div>
          </div>
        </div>
      );
    }
  }

};


// WEBPACK FOOTER //
// ./src/pages/MantMaestros/MaestroTreeNode.js